import { render, staticRenderFns } from "./AdminBooking.vue?vue&type=template&id=23b390be&"
import script from "./AdminBooking.vue?vue&type=script&lang=js&"
export * from "./AdminBooking.vue?vue&type=script&lang=js&"
import style0 from "./AdminBooking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports